<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <mat-icon>close</mat-icon>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown [options]="phoneTypes" formControlName="type" optionLabel="name" optionValue="value"
            placeholder="Select Phone Type"></p-dropdown>
            <label for="Select Phone Type">Select Phone Type</label>
            @for (validation of validationMessages.type; track validation) {
              <span>
                @if (form1.get('type').hasError(validation.type) && (form1.get('type').dirty || form1.get('type').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="countryCode" id="countryCode" type="text" pInputText>
            <label for="countryCode">Country Code</label>
            @for (validation of validationMessages.countryCode; track validation) {
              <span>
                @if (form1.get('countryCode').hasError(validation.type) && (form1.get('countryCode').dirty || form1.get('countryCode').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <!-- <p-inputMask formControlName="phoneNum" id="phoneNum" mask="(999) 999-9999" type="text">
          </p-inputMask> -->
          <input formControlName="phoneNum" id="phoneNum" type="text" pInputText>
          <label for="phoneNum">Phone Number</label>
          @for (validation of validationMessages.phoneNum; track validation) {
            <span>
              @if (form1.get('phoneNum').hasError(validation.type) && (form1.get('phoneNum').dirty || form1.get('phoneNum').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <!--<div class="col-lg-6">
      <span class="p-float-label required-field w-100 mb-3">
        <p-dropdown [options]="persons" formControlName="personId" appendTo="body" optionLabel="name"
          optionValue="personId" [filter]="true" filterBy="name" [showClear]="false"
          placeholder="Select Person">
        </p-dropdown>
        <label for="Select Person">Select Person</label>
        <span *ngFor="let validation of validationMessages.personId">
          <small class="p-invalid"
            *ngIf="form1.get('personId').hasError(validation.type) && (form1.get('personId').dirty || form1.get('personId').touched)">{{validation.message}}
          </small>
        </span>
      </span>
    </div>-->
  </div>
</div>
<hr>
  <div class="row m-0">
    <div class="col-lg-12">
      <div class="btn-group">
        <div class="button-group">
          @if (personPhoneId) {
            <button pButton class="btn-delete p-button-outlined p-button-danger"
            (click)="onFormDelete()">Delete Phone</button>
          }
        </div>

        <div class="button-group">
          <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
          @if (!personPhoneId) {
            <button pButton class="btn-addt p-button" (click)="formAdd()">Add Phone</button>
          }

          @if (personPhoneId) {
            <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update Phone</button>
          }
        </div>
      </div>
    </div>
  </div>
</div>